export const toRegionCode = (value?: string): string | undefined => {
    const code = value?.trim().toLowerCase();
    return code && /^[a-z]{2}$/.test(code) ? code : undefined;
};
